import Vue from 'vue'
// 1. 导入
import Vuex from 'vuex'
// 2. 注册
Vue.use(Vuex)

// 3. 实例化对象
export default new Vuex.Store({
  // vuex操作localStorage
  // localStorage使用类型：获取、修改
  state: {
    // 配置用户账户信息成员
    user: JSON.parse(localStorage.getItem('userinfo')),
    classid: JSON.parse(localStorage.getItem('classid')),
    classid1: JSON.parse(localStorage.getItem('classid1')),
    classid2: JSON.parse(localStorage.getItem('classid2')),
    listening: JSON.parse(localStorage.getItem('listening')),
    watching: JSON.parse(localStorage.getItem('watching')),
    watching1: JSON.parse(localStorage.getItem('watching1')),
    watchingear: JSON.parse(localStorage.getItem('watchingear')),
    watchingears: JSON.parse(localStorage.getItem('watchingears')),
    addbookId: JSON.parse(localStorage.getItem('addbookId')),
    addbookIds: JSON.parse(localStorage.getItem('addbookIds')),
    UnitId: JSON.parse(localStorage.getItem('UnitId')),
    UnitIds: JSON.parse(localStorage.getItem('UnitIds')),
    addbookIdss: JSON.parse(localStorage.getItem('addbookIdss')),
    Chapter: JSON.parse(localStorage.getItem('Chapter')),
    addbookIdsss: JSON.parse(localStorage.getItem('addbookIdsss')),
    Chapters: JSON.parse(localStorage.getItem('Chapters')),
    UnitIdss: JSON.parse(localStorage.getItem('UnitIdss')),
    addbookIdss1: JSON.parse(localStorage.getItem('addbookIdss1')),
    Chapterss: JSON.parse(localStorage.getItem('Chapterss')),
    sentencepractice: JSON.parse(localStorage.getItem('sentencepractice')),
    sentencepracticeearbs: JSON.parse(localStorage.getItem('sentencepracticeearbs')),
    sentencepracticeear1: JSON.parse(localStorage.getItem('sentencepracticeear1')),
    sentencepracticeear: JSON.parse(localStorage.getItem('sentencepracticeear')),
    sentencepracticeears: JSON.parse(localStorage.getItem('sentencepracticeears')),
    testing: JSON.parse(localStorage.getItem('testing')),
    testingear: JSON.parse(localStorage.getItem('testingear')),
    testingears: JSON.parse(localStorage.getItem('testingears')),
    testingearbs: JSON.parse(localStorage.getItem('testingearbs')),
    testingear1: JSON.parse(localStorage.getItem('testingear1')),
    listeningear0: JSON.parse(localStorage.getItem('listeningear0')),
    watchingear0: JSON.parse(localStorage.getItem('watchingear0')),
    sentencepracticeear0: JSON.parse(localStorage.getItem('sentencepracticeear0')),
    testingear0: JSON.parse(localStorage.getItem('testingear0'))
    // orgid: JSON.parse(sessionStorage.getItem('id'))
  },
  mutations: {
    // 修改用户信息
    updateUser (state, data) {
      // 1. vuex的共享数据要修改，响应式就来了
      state.user = data
      // 2. localStorage数据要修改，持久存储，后期f5刷新会使用
      localStorage.setItem('userinfo', JSON.stringify(data))
    },
    banji_ming (state, data) {
      state.classid = data
      localStorage.setItem('classid', JSON.stringify(data))
    },
    banji_tian (state, data) {
      state.classid1 = data
      localStorage.setItem('classid1', JSON.stringify(data))
    },
    banji_tian1 (state, data) {
      state.classid2 = data
      localStorage.setItem('classid2', JSON.stringify(data))
    },
    listening (state, data) {
      state.listening = data
      localStorage.setItem('listening', JSON.stringify(data))
    },
    watching (state, data) {
      state.watching = data
      localStorage.setItem('watching', JSON.stringify(data))
    },
    watching1 (state, data) {
      state.watching1 = data
      localStorage.setItem('watching1', JSON.stringify(data))
    },
    watchingear (state, data) {
      state.watchingear = data
      localStorage.setItem('watchingear', JSON.stringify(data))
    },
    watchingears (state, data) {
      state.watchingears = data
      localStorage.setItem('watchingears', JSON.stringify(data))
    },
    addbookId (state, data) {
      state.addbookId = data
      localStorage.setItem('addbookId', JSON.stringify(data))
    },
    addbookIds (state, data) {
      state.addbookIds = data
      localStorage.setItem('addbookIds', JSON.stringify(data))
    },
    UnitId (state, data) {
      state.UnitId = data
      localStorage.setItem('UnitId', JSON.stringify(data))
    },
    UnitIds (state, data) {
      state.UnitIds = data
      localStorage.setItem('UnitIds', JSON.stringify(data))
    },
    addbookIdss (state, data) {
      state.addbookIdss = data
      localStorage.setItem('addbookIdss', JSON.stringify(data))
    },
    Chapter (state, data) {
      state.Chapter = data
      localStorage.setItem('Chapter', JSON.stringify(data))
    },
    addbookIdsss (state, data) {
      state.addbookIdsss = data
      localStorage.setItem('addbookIdsss', JSON.stringify(data))
    },
    Chapters (state, data) {
      state.Chapters = data
      localStorage.setItem('Chapters', JSON.stringify(data))
    },
    UnitIdss (state, data) {
      state.UnitIdss = data
      localStorage.setItem('UnitIdss', JSON.stringify(data))
    },
    addbookIdss1 (state, data) {
      state.addbookIdss1 = data
      localStorage.setItem('addbookIdss1', JSON.stringify(data))
    },
    Chapterss (state, data) {
      state.Chapterss = data
      localStorage.setItem('Chapterss', JSON.stringify(data))
    },
    sentencepractice (state, data) {
      state.sentencepractice = data
      localStorage.setItem('sentencepractice', JSON.stringify(data))
    },
    sentencepracticeearbs (state, data) {
      state.sentencepracticeearbs = data
      localStorage.setItem('sentencepracticeearbs', JSON.stringify(data))
    },
    sentencepracticeear1 (state, data) {
      state.sentencepracticeear1 = data
      localStorage.setItem('sentencepracticeear1', JSON.stringify(data))
    },
    sentencepracticeear (state, data) {
      state.sentencepracticeear = data
      localStorage.setItem('sentencepracticeear', JSON.stringify(data))
    },
    sentencepracticeears (state, data) {
      state.sentencepracticeears = data
      localStorage.setItem('sentencepracticeears', JSON.stringify(data))
    },
    testing (state, data) {
      state.testing = data
      localStorage.setItem('testing', JSON.stringify(data))
    },
    testingear (state, data) {
      state.testingear = data
      localStorage.setItem('testingear', JSON.stringify(data))
    },
    testingears (state, data) {
      state.testingears = data
      localStorage.setItem('testingears', JSON.stringify(data))
    },
    testingearbs (state, data) {
      state.testingearbs = data
      localStorage.setItem('testingearbs', JSON.stringify(data))
    },
    testingear1 (state, data) {
      state.testingear1 = data
      localStorage.setItem('testingear1', JSON.stringify(data))
    },
    listeningear0 (state, data) {
      state.listeningear0 = data
      localStorage.setItem('listeningear0', JSON.stringify(data))
    },
    watchingear0 (state, data) {
      state.watchingear0 = data
      localStorage.setItem('watchingear0', JSON.stringify(data))
    },
    sentencepracticeear0 (state, data) {
      state.sentencepracticeear0 = data
      localStorage.setItem('sentencepracticeear0', JSON.stringify(data))
    },
    testingear0 (state, data) {
      state.testingear0 = data
      localStorage.setItem('testingear0', JSON.stringify(data))
    }
  },
  actions: {},
  modules: {}
})
